module.exports = __webpack_public_path__ + "img/basic.fe745ea2.png";